module.exports = __webpack_public_path__ + "static/blog-1-6-4e21fdf630007fd789ab67cf51752771.jpg";